class DecLocalFormat extends HTMLInputElement {
  static get DECIMAL_SEPARATOR () {
    return new Intl.NumberFormat(navigator.language).format(9.9).replace(/9/g, '')
  }

  connectedCallback () {
    this.pattern = this._pattern()
    this.addEventListener('input', () => {
      if (this.value !== '') {
        const original = this.originalValue()
        if (isNaN(original)) {
          this.value = this.value.slice(0, -1)
        } else {
          this.value = this.value.replace(/[,.]/g, DecLocalFormat.DECIMAL_SEPARATOR)
        }
      }
    })
  }

  originalValue () {
    return this.value.replace(new RegExp(`[${DecLocalFormat.DECIMAL_SEPARATOR}]`, 'g'), '')
  }

  _pattern () {
    return `[0-9]{0,6}([${DecLocalFormat.DECIMAL_SEPARATOR}][0-9]{0,3})?`
  }
}

export default DecLocalFormat
